var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 135.909 136.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-1865.122 -540.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M1932.947,623.819c-1.58,0-3.162.025-4.741-.006-1.737-.034-2.339-.632-2.37-2.353a36.3,36.3,0,0,1,.663-7.9,18.576,18.576,0,0,1,5.208-9.324c2.358-2.425,4.823-4.749,7.155-7.2a14.2,14.2,0,0,0,3.739-6.892c.753-3.475-1.172-8.658-5.851-10a16.193,16.193,0,0,0-6.548-.289c-2.69.337-4.394,2.182-5.9,4.189a26.916,26.916,0,0,0-2.084,3.475c-.913,1.694-1.607,1.991-3.4,1.224-2.542-1.084-5.059-2.224-7.6-3.3-1.725-.73-2.3-1.878-1.466-3.758a25.4,25.4,0,0,1,13.576-13.714,24.233,24.233,0,0,1,7.23-1.573,28.774,28.774,0,0,1,11.346,1.171,19.9,19.9,0,0,1,13.536,13.141c2.763,8.019,1.253,15.346-4.067,21.873-1.595,1.957-3.443,3.71-5.162,5.567-1.188,1.283-2.393,2.552-3.522,3.885-1.614,1.905-1.972,4.257-2.179,6.634-.074.841-.013,1.692-.048,2.538-.077,1.834-.792,2.567-2.6,2.606C1936.221,623.847,1934.585,623.819,1932.947,623.819Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M1923.5,640.734a9.286,9.286,0,0,1,9.436-9.462,9.443,9.443,0,0,1,9.3,9.462,9.252,9.252,0,0,1-9.384,9.353A9.122,9.122,0,0,1,1923.5,640.734Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M2001.03,608.157a67.954,67.954,0,1,1-69.044-68.069A67.938,67.938,0,0,1,2001.03,608.157Zm-10.707.03a57.258,57.258,0,1,0-56.858,57.374A57.135,57.135,0,0,0,1990.323,608.187Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.b0f80c0f282c4647d07a277fc7b3568b.svg";
export { ForwardRef as ReactComponent };